<template>
    <score-badge v-if="!!generalScore" v-tooltip.large.left="tooltipHtml" :score="generalScore">
        {{ generalScore }}
    </score-badge>
    <span v-else v-tooltip:grey="'No info found!'"></span>
</template>
<script src="./ScoreTooltip.ts"></script>
